module.exports = __webpack_public_path__ + "modules/platform/img/file_type_df_icon.png";